<template>
  <modal
    :name="name"
    v-bind="{
      ...defaultOptions,
      ...dimensions,
      ...options,
    }"
    class="relative roundedmodal"
    @before-open="handleEvents"
    @opened="handleEvents"
    @before-close="handleEvents"
    @closed="handleEvents"
  >
    <slot />
  </modal>
</template>

<script>
const defaultOptions = {
  resizable: false,
  adaptive: true,
  scrollable: true,
};

export default {
  data() {
    return {
      defaultOptions,
    };
  },
  props: {
    name: [String, Number],
    openOnMount: Boolean,
    closeButton: {
      type: Boolean,
      default: true,
    },

    options: Object,

    spread: Boolean,
  },

  mounted() {
    if (this.openOnMount) {
      return this.$modal.show(this.name);
    }
  },
  beforeDestroy() {
    this.$modal.hide(this.name);
  },
  computed: {
    dimensions() {
      if (!this.spread) return {};

      return {
        width: "90%",
        height: "90%",
      };
    },
  },
  methods: {
    handleEvents(e) {
      this.$emit(e.state, e);
    },
  },
};
</script>

<style></style>
